module.exports = __webpack_public_path__ + "img/OrbitInvest-logo.8cbfd0eb.png";